export type ColorHarmony =
    | 'monochromatic'
    | 'analogous'
    | 'complementary'
    | 'triadic'
    | 'custom';

export type ToneVariant = 'c1' | 'c2' | 'o1' | 'o2' | 'base';

export interface ColorWithTones {
    base: string;
    c1: string;
    c2: string;
    o1: string;
    o2: string;
    contrastOnLight: string;
    contrastOnDark: string;
}

export interface ColorPaletteConfig {
    harmony: ColorHarmony;
    colorCount: 1 | 2 | 3;
    baseColor1: string;
    baseColor2?: string;
    baseColor3?: string;
}

export interface GeneratedPalette {
    colors: ColorWithTones[];
    harmony: ColorHarmony;
}

export const HARMONY_LABELS: Record<ColorHarmony, string> = {
    monochromatic: 'Monocromático',
    complementary: 'Complementario',
    triadic: 'Triádico',
    analogous: 'Análogo',
    custom: 'Personalizado',
};

export const TONE_LABELS: Record<ToneVariant, string> = {
    c1: 'Muy claro',
    c2: 'Claro',
    o1: 'Muy oscuro',
    o2: 'Oscuro',
    base: 'Base',
};

/**
 * Reglas de cantidad de colores por armonía.
 * - `fixed`: valor único obligatorio (ocultar selector)
 * - `options`: valores seleccionables (mostrar selector)
 */
export const HARMONY_COLOR_COUNT_RULES: Record<
    ColorHarmony,
    { fixed: 1 | 2 | 3 } | { options: (1 | 2 | 3)[]; default: 1 | 2 | 3 }
> = {
    monochromatic: { fixed: 1 },
    complementary: { fixed: 2 },
    triadic: { fixed: 3 },
    analogous: { options: [2, 3], default: 3 },
    custom: { options: [1, 2, 3], default: 1 },
};
